<app-loading *ngIf="isLoading$ | async" [options]="(loadingOpts$ | async) ?? undefined" />

<div class="app-body mb-0" [ngClass]="{ 'app-body-blur': blurPage$ | async }">
  <!-- Nav Bar -->
  <app-navbar
    [hidden]="navbarMinimized"
    [class.spp-navbar-hide]="navbarMinimized"
    [class.spp-navbar-show]="!navbarMinimized" />
  <!-- Main content -->
  <main [style.overflow]="(disableScroll$ | async) ? 'hidden' : 'auto'">
    <div class="main-content">
      <router-outlet />
    </div>
  </main>
</div>
